import { createSelector } from "reselect"
import { computeFactorsColumns } from "helpers/assets"
import { getSelectedView } from "selectors/assets"
import { getSelectedViewIsContentSet } from "selectors/contentSets"
import { getSelectedMetricType, getContentSetCategoryFactors } from "."
import { getModelFactors } from "selectors/modelMetadata"

const getFactors = createSelector(
  [getModelFactors, getContentSetCategoryFactors],
  (factors, contentSetFactors) => contentSetFactors || factors,
)

export const getFactorsColumns = createSelector(
  [getFactors, getSelectedView, getSelectedMetricType, getSelectedViewIsContentSet],
  computeFactorsColumns,
)
